import { useEffect } from 'react';

export function CompanyDocumentTitle({ name }: { name?: string }) {
  useEffect(() => {
    document.title = name ? `${name} · Poneva` : 'Poneva';
    return () => {
      document.title = 'Poneva';
    };
  }, [name]);
  return null;
}
